<template>
  <div class="splash" />
</template>

<script lang="ts" setup>
import { RouterAuthType, RouterNameType } from '@/core/data/config/uiConfig.interface';
import { useAuthStore } from '@/stores/auth.store';
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

onMounted(async () => {
  if (user.value?.email) {
    router.push({ name: RouterNameType.SPARKS });
  } else {
    router.push({ name: RouterAuthType.AUTH_SELECT });
  }
});
</script>

<style lang="scss">
.splash {
  display: flex;
  width: 100%;
  height: 100%;
  background: var(--color-linear-gradient-vertical) var(--color-dark-700);
}
</style>
